var moment = require("moment-timezone"); moment.tz.add('Asia/Dhaka|+06|-60|0||16e6');